module.exports = __webpack_public_path__ + "static/media/right.9406612d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/cybersport/right.png
// module id = 2455
// module chunks = 7